/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Error de carga a nivel sección: mensaje + botón Reintentar real.
 * (Pull-to-refresh no existe con mouse en web — antes el copy decía
 * "Deslizá para reintentar" y la sección quedaba sin salida.)
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { styles } from '../ReportsScreen.styles';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors';

type Props = {
  message: string;
  onRetry: () => void;
  accessibilityLabel?: string;
};

export function ReportsLoadErrorRow({ message, onRetry, accessibilityLabel }: Props) {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: spacing.sm, flexWrap: 'wrap' }}>
      <Text style={[styles.caption, { color: ticketColors.bad, flexShrink: 1 }]}>{message}</Text>
      <TouchableOpacity
        onPress={onRetry}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel ?? 'Reintentar'}
      >
        <Text style={styles.linkText}>Reintentar</Text>
      </TouchableOpacity>
    </View>
  );
}
